import { Typography } from "@/components/typography";
import { OptionType } from "@/types/checkout";
import clsx from "clsx";
import { ErrorMessage } from "formik";
import { FC } from "react";
import Select from "react-select";

interface props {
  sx?: string;
  title?: string;
  name: string;
  placeholder?: string;
  options: { value: string; label: string }[];
  onChange: (name: string, data: OptionType) => void;
  optional?: boolean;
  value: OptionType | null;
  noOptionsStateMessage?: boolean;
}

const StateNoOptionMessage = (message: string) => (
  <option className="cursor-pointer text-sm  px-3 py-3 rounded text-gray-700">
    {message}
  </option>
);

const valueFound = (
  option: { value: string; label: string }[],
  value: string,
) => option.findIndex((item) => item.value !== value) >= 0;

const SelectInput: FC<props> = ({
  sx,
  name,
  placeholder,
  title,
  options,
  onChange,
  optional,
  value,
  noOptionsStateMessage,
  // ref,
}) => (
  <div className={sx}>
    {title ? (
      <label htmlFor={name} className="flex items-center gap-1 ">
        <Typography
          tag="p"
          className="my-2  text-sm font-[400] tracking-wide border-0"
        >
          {title}{" "}
          {!optional && (
            <Typography tag="span" className="text-red">
              *
            </Typography>
          )}
        </Typography>{" "}
      </label>
    ) : null}

    <Select
      className="basic-single py-1 h-fit"
      classNamePrefix="custom-select"
      unstyled
      value={value}
      backspaceRemovesValue
      noOptionsMessage={({ inputValue }) => {
        if (noOptionsStateMessage) {
          return inputValue
            ? valueFound(options, inputValue) &&
                StateNoOptionMessage("No Options")
            : StateNoOptionMessage("Please select the Country");
        }
        return StateNoOptionMessage("No Options");
      }}
      classNames={{
        container: ({ isFocused }) =>
          clsx(
            "border border-gray-200 px-3 rounded-md",
            isFocused && "border-2 border-primary",
          ),
        placeholder: () => "text-gray-400",
        dropdownIndicator: () => "text-gray-400",
        clearIndicator: () => "hidden text-gray-400",
        menuList: () => "bg-white h-[250px] no-scrollbar",
        menu: () =>
          "absolute left-0 my-2 rounded-lg overflow-hidden border shadow-lg",
        option: ({ isSelected, isFocused }) =>
          clsx(
            "cursor-pointer text-sm  border-b px-3 py-3 rounded text-gray-700",
            isSelected && "px-3 bg-[#3EC6CF]",
            isFocused && "bg-[#d7ffff] text-black",
          ),
      }}
      isClearable
      id={name}
      isSearchable
      name={name}
      options={options}
      placeholder={placeholder}
      onChange={(option) => onChange(name, option as OptionType)}
    />

    <ErrorMessage
      name={name}
      component="span"
      className="text-red text-sm my-1"
    />
  </div>
);

export default SelectInput;
